"use client";

import nextDynamic from "next/dynamic";
import type { HeroAgentTranscriptProps } from "./HeroAgentTranscript";

const HeroAgentTranscript = nextDynamic(() => import("./HeroAgentTranscript").then(mod => mod.HeroAgentTranscript));

export default function HeroAgentTranscriptWrapper(props: HeroAgentTranscriptProps) {
  return <HeroAgentTranscript {...props} />;
}
